export const URL_REGEX = new RegExp(
    '^(https:\\/\\/)?' + // protocol (http or https)
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?' + // port
        '(\\/[-a-z\\d%_.~+,]*)*' + // path (allows comma in path)
        '(\\?[;&amp;a-z\\d%_.~+=,-]*)?' + // query string (allows comma in query)
        '(\\#[-a-z\\d%_.~+=,-]*)?$', // fragment locator (allows comma in fragment)
    'i'
);


export const HTTPS_URL_REGEX = new RegExp(
    '^(https:\\/\\/)' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name and extension
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?' + // port
        '(\\/[-a-z\\d%_.~+,]*)*' + // path (allowed comma in path)
        '(\\?[;&amp;a-z\\d%_.~+=,-]*)?' + // query string (allowed comma in query)
        '(\\#[-a-z\\d%_.~+=,-]*)?$', // fragment locator (allowed comma in fragment)
    'i'
);

